import type { Location } from '../api/types';

interface LocationPillsProps {
  locations: Location[];
  selectedId: string | null;
  onChange: (id: string) => void;
}

export function LocationPills({ locations, selectedId, onChange }: LocationPillsProps) {
  return (
    <div style={{
      display: 'flex',
      background: 'var(--bg-subtle)',
      border: '1px solid var(--border)',
      borderRadius: 6,
      padding: 2,
      gap: 2,
    }}>
      {locations.map(loc => (
        <button
          key={loc.id}
          onClick={() => onChange(loc.id)}
          aria-pressed={selectedId === loc.id}
          style={{
            padding: '6px 12px',
            borderRadius: 4,
            fontSize: '0.8125rem',
            fontWeight: 700,
            background: selectedId === loc.id ? 'var(--bg)' : 'transparent',
            color: selectedId === loc.id ? 'var(--text)' : 'var(--text-muted)',
            border: selectedId === loc.id ? '1px solid var(--border)' : '1px solid transparent',
            cursor: 'pointer',
          }}
        >
          {loc.name}
        </button>
      ))}
    </div>
  );
}
